import Slider from "react-slick";
import { ArrowLeft, ArrowRight } from "../../atoms/Icon/Icon";
import styles from "./CarouselSection.module.scss";
import CardIdea from "../../molecules/Card/CardIdea";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../utils/routes";
import { ideaCards } from "../../../utils/mock";
import Button from "../../atoms/Button";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getStaticData } from "../../../utils/services";

export type CarouselSectionProps = {
  className?: string;
};

export const CarouselSection = ({ className = "" }: CarouselSectionProps) => {
  const { t } = useTranslation("HOME");
  const navigate = useNavigate();
  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);

  const [stat, setStat] = useState<StaticData>({
    published: [],
    statistics: { approved: 0, suggestions: 0, topics: 0 },
  });

  useEffect(() => {
    getStaticData().then((data) => {
      setStat(data.data);
    });
  }, []);
  useEffect(() => {
    const onResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);

  const setSlideToShow = () => {
    if (screenWidth < 1600) {
      return 3;
    } else {
      return 5;
    }
  };

  return (
    <section className={[styles.exploreIdeas, className].join(" ")}>
      <h1 className={styles.esploraTutteLe}>{t("CAROUSEL")}</h1>
      <div className={styles.carouselContainer}>
        <Slider
          className={styles.desktopSlider}
          infinite={true}
          // centerMode={true}
          centerPadding="100px"
          slidesToShow={setSlideToShow()}
          slidesToScroll={1}
          speed={700}
          nextArrow={
            <div className={styles.sliderItems}>
              <ArrowRight />
            </div>
          }
          prevArrow={
            <div className={styles.sliderItems4}>
              <ArrowLeft />
            </div>
          }
        >
          {stat.published.map((i, index) => (
            <CardIdea
              key={index}
              category={i.topic}
              idea_description={i.description}
              idea_name={i.title}
              idea_owner={i.author}
            />
          ))}
        </Slider>
        <div className={styles.mobileSlider}>
          {stat.published.map((i, index) => (
            <CardIdea
              key={index}
              category={i.topic}
              idea_description={i.description}
              idea_name={i.title}
              idea_owner={i.author}
            />
          ))}
        </div>
      </div>
      <Button
        className={styles.carouselBtn}
        contrast
        onClick={() => navigate(routes.ideas)}
      >
        <b>{t("BUTTON.EXPLORE_IDEAS")}</b>
      </Button>
    </section>
  );
};
